<template>
    <div class="entiretyClass">
        <common-left @hasSubMenu="hasSubMenu" ref="menuRef"></common-left>
        <div class="content">
            <common-top @messageLog="messageLog"></common-top>
            <div class="commonCenter" :style="hasSubMenuValue?'padding-left:100px':'padding-left:0'">
                <el-scrollbar style="height: 100%;">
                    <router-view></router-view>
                </el-scrollbar>
            </div>
        </div>
    </div>
</template>

<script>
    import commonLeft from './layout/common_left'
    import commonTop from './layout/common_top'
    export default {
        name: "index",
        data(){
            return{
                hasSubMenuValue:false
            }
        },
        components: {
            commonLeft,
            commonTop
        },
        methods: {
            hasSubMenu(val){
                this.hasSubMenuValue = val
            },
            // 消息定位
            messageLog(){
                let menuList = JSON.parse(window.sessionStorage.getItem('menuList') || '[]')
                menuList.some(item => {
                    if(item.url === '/stationMessageLog'){
                        this.resetSetItem('menuActiveId',item.uuid)
                        this.$refs.menuRef.routeHandle(item.uuid)
                        return true
                    } else {
                        this.childrenRoute(item.children,'/stationMessageLog',item)
                    }
                })
            },
            // 子菜单
            childrenRoute(children,url,item){
                if(children){
                    children.some(child =>{
                        if(child.url === url){
                            this.resetSetItem('menuActiveId',child.uuid)
                            this.$refs.menuRef.routeHandle(child.uuid)
                            return true
                        } else {
                            this.childrenRoute(child.children,url,item)
                        }
                    })
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .entiretyClass{
        width: 100%;
        height: 100%;
        .content{
            margin-left: 90px;
            height: 100%;
            background: #fff;
            border-top-left-radius: 20px;
            position: relative;
            .commonCenter{
                width: 100%;
                height: 100%;
                padding-top: 60px;
                /deep/.el-scrollbar__wrap {
                    overflow-x: hidden;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/index.vue